import ArticlesCard from "SanityComponents/ArticlesCard";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import style from "./style.module.css";
import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import formatUrl from "utils/FormatUrl";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});
function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

function index(props) {
  const refCarousel = useRef(null);
  const [dotIndex, setDotIndex] = useState(0);
  const [dots, setDots] = useState([...Array(3).fill(1)]);

  const handleScroll = () => {
    const scrollLeft = refCarousel.current.scrollLeft;
    const cardWidth = refCarousel.current.offsetWidth;
    const activeCardIndex = Math.round(scrollLeft / cardWidth);
    setDotIndex(activeCardIndex);
  };

  useEffect(() => {
    const scrollable = refCarousel.current;
    scrollable?.addEventListener("scroll", handleScroll);

    return () => {
      scrollable.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={style.annoncesLpCon}>
      <div className={style.annoncesContainer}>
        <div className={style.titleContainer}>
          <h2 className={style.title}>
            {/* <span>Les conseils Agenz</span> pour votre projet de location */}
            {props.title ? props.title : ""}
          </h2>
        </div>
        <div>
          {props.data ? (
            <div className={style.cardsContainer} ref={refCarousel}>
              {props.data.map((elem) => {
                return (
                  <>
                    <ArticlesCard
                      title={elem.title ? elem.title[props.lang] : null}
                      subtitle={
                        elem.subtitle ? elem.subtitle[props.lang] : null
                      }
                      imageUrl={urlFor(elem.mainImage)
                        .width(404)
                        .height(187)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()}
                      href={formatUrl(
                        `${
                          props.articlesType == "location"
                            ? "/louer/guide-location/"
                            : props.articlesType == "achat"
                            ? "/acheter/guide/"
                            : ""
                        }${elem.slug.current}`,
                        props.lang
                      )}
                    />
                  </>
                );
              })}
            </div>
          ) : null}

          <div className={style.dotContainer}>
            {dots.map((item, key) => {
              return (
                <div
                  className={`${
                    key === dotIndex ? style.dotActive : style.dot
                  }`}
                ></div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
